import { Box, BoxProps } from "@mui/material";
import Account from "../assets/svg/account-svgrepo-com.svg";
import sim from "../assets/svg/sim_management_icon.svg";
import device from "../assets/svg/device_management_icon.svg"; 
import user from "../assets/svg/user.svg";
import dealers from "../assets/svg/location-dealer.svg";
import VinJourney from "../assets/svg/vin_journey_icon.svg";
import kyc from "../assets/svg/kyc-user_svgrepo.com.svg";
import Eolt from "../assets/svg/eolt_report_svgrepo.com.svg";
import CertificateManager from "../assets/svg/certificate-svgrepo-com.svg";
import CertificateExpiry from "../assets/svg/certificate_expiry.svg";
import DealerTickets from "../assets/svg/dealer_ticket.svg";
import AIS140Requests from "../assets/svg/ais140_ticket.svg";
import VinImeiLogs from "../assets/svg/vin_imei_logs.svg";
import NeftKyc from "../assets/svg/KYC_Icon-black.svg"
import Payments from "../assets/svg/payments.svg"
import SupportContact from "../assets/svg/support_contact.svg"
import PdRevival from "../assets/svg/pd_revival.svg"


const getSVGComponent = (svgPath: string) => {
    const fn = Object.defineProperty(
        function (props: BoxProps & { color?: string }) {
            return (
                <Box
                    component="img"
                    height={"25px"}
                    width={"25px"}
                    src={svgPath}
                    style={{ filter: props.color === "#fff" ? "invert(1) brightness(2)" : undefined }}
                    {...props}
                />
            );
        },
        "name",
        { value: svgPath.split("/").at(-1) + "SVGImage" },
    );
    return fn;
};


const DrawerItems = [
    {
        text: "Device Manager",
        key: "device-manager",
        path: "/device-manager",
        icon: getSVGComponent(device),
        children: [],
    },
    {
        text: "SIM Management",
        key: "sim-management",
        path: "/sim-management",
        icon: getSVGComponent(sim),
        children: [],
    },
    {
        text: "Dealers",
        key: "dealers",
        path: "/dealers",
        icon: getSVGComponent(dealers),
        children: [],
    },
     {
        text: "VIN Journey",
        key: "vin-journey",
        path: "/vin-journey",
        icon: getSVGComponent(VinJourney),
        children: [],
    },
       {
        text: "Certificate Manager",
        key: "certificate-manager",
        path: "/certificate-manager",
        icon: getSVGComponent(CertificateManager),
        children: [],
    },
    {
        text: "PD Revival",
        key: "pd-cases",
        path: "/pd-cases",
        icon: getSVGComponent(PdRevival),
        children: [],
    },
    {
        text: "Certificate Expiry",
        key: "certificate-expiry",
        path: "/certificate-expiry",
        icon: getSVGComponent(CertificateExpiry),
        children: [],
    },
     {
        text: "KYC Details",
        key: "kyc-details",
        path: "/kyc-details",
        icon: getSVGComponent(kyc),
        children: [],
    },
    {
        text: "EOLT Reports",
        key: "eolt-reports",
        path: "/eolt-reports",
        icon: getSVGComponent(Eolt),
        children: [],
    },
    {
        text: "Dealer Tickets",
        key: "dealer-tickets",
        path: "/dealer-tickets",
        icon: getSVGComponent(DealerTickets),
        children: [],
    },
    {
        text: "AIS Tickets",
        key: "ais-tickets",
        path: "/ais-tickets",
        icon: getSVGComponent(AIS140Requests),
        children: [],
    },
    {
        text: "VIN IMEI Logs",
        key: "vin-imei-logs",
        path: "/vin-imei-logs",
        icon: getSVGComponent(VinImeiLogs),
        children: [],
    },
    {
        text: "NEFT KYC",
        key: "neft-kyc",
        path: "/neft-kyc",
        icon: getSVGComponent(NeftKyc),
        children: [],
    },

    {
        text: "Users",
        key: "user-management",
        path: "/user-management",
        icon: getSVGComponent(user),
        children: [],
    },
    {
        text: "Payments",
        key: "payments",
        path: "/payments",
        icon: getSVGComponent(Payments),
        children: [],
    },
    {
        text: "Support Contact",
        key: "support-contact",
        path: "/support-contact",
        icon: getSVGComponent(SupportContact),
        children: [],
    },
    {
        text: "Account",
        key: "account",
        path: "/account",
        icon: getSVGComponent(Account),
        children: [],
    },
];


export default DrawerItems;